import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import { SiteConfigProvider } from "@/contexts/SiteConfigContext";
import { ThemeProvider } from "@/contexts/ThemeContext";

import PublicLayout from "@/components/layout/PublicLayout";
import AdminLayout from "@/components/layout/AdminLayout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Survey from "@/pages/Survey";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminSiteConfig from "@/pages/admin/AdminSiteConfig";
import AdminSkills from "@/pages/admin/AdminSkills";
import AdminProjects from "@/pages/admin/AdminProjects";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminTimeline from "@/pages/admin/AdminTimeline";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminSurveys from "@/pages/admin/AdminSurveys";

// Old URLs from the previous design keep working.
function ParamRedirect({ to, param }) {
  const params = useParams();
  return <Navigate to={`${to}/${params[param]}`} replace />;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <SiteConfigProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Landing />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/projects/:id" element={<ProjectDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/survey" element={<Survey />} />
                <Route path="/survey/:slug" element={<Survey />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/skills" element={<Navigate to="/about" replace />} />
                <Route path="/timeline" element={<Navigate to="/about" replace />} />
                <Route path="/builds" element={<Navigate to="/projects" replace />} />
                <Route path="/builds/:id" element={<ParamRedirect to="/projects" param="id" />} />
                <Route path="/garage" element={<Navigate to="/about" replace />} />
                <Route path="/radio" element={<Navigate to="/blog" replace />} />
                <Route path="/radio/:slug" element={<ParamRedirect to="/blog" param="slug" />} />
                <Route path="/test-drive" element={<Navigate to="/survey" replace />} />
                <Route path="/test-drive/:slug" element={<ParamRedirect to="/survey" param="slug" />} />
                <Route path="*" element={<NotFound />} />
              </Route>

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<AdminDashboard />} />
                <Route path="site" element={<AdminSiteConfig />} />
                <Route path="skills" element={<AdminSkills />} />
                <Route path="projects" element={<AdminProjects />} />
                <Route path="blog" element={<AdminBlog />} />
                <Route path="timeline" element={<AdminTimeline />} />
                <Route path="messages" element={<AdminMessages />} />
                <Route path="surveys" element={<AdminSurveys />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" richColors />
        </SiteConfigProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
